//#region imports
import React, {useEffect, useState} from 'react';

// custom components
import { Text, Footer, PageNavigator } from '../../components/atoms';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Colors } from '../../styles/index';
// tremor
import { Callout } from "@tremor/react";

//#endregion

const GettingStarted = (props) => {

    const border = false; 

    return (
        <>
            
            {/* Title & Prerequisites */}
            <Row>
                <Container className='mt-5' style={{borderWidth:border && 1, borderStyle: border && 'solid' }}>

                    {/* Title Text */}    
                    <Text.Title>Getting Started</Text.Title>
                    <Text.Subtitle>Installation and Integration</Text.Subtitle>
                    <Text.Text>Here we run through what is required to integrate your system with PRM Connect.</Text.Text>

                    <Text.Heading>Prerequisites</Text.Heading>
                    <ul>
                        <li><Text.Text>Client ID</Text.Text></li>
                        <li><Text.Text>Client Secret</Text.Text></li>
                    </ul>

                    <hr className='mt-5' />

                </Container>
            </Row>
            
            {/* Contact Team */}
            <Row>
                <Col>
                    <Container  className='mt-3' style={{borderWidth:border && 1, borderStyle: border && 'solid' }}>
                        <Text.Heading>1. Contact our Team</Text.Heading>
                        <Text.Text>In order to give your airline access to the connect API, you first need to   
                            <a href={'https://prmassist.com/contact'} style={{color:Colors.PRM_LIGHT_BLUE, marginLeft: 4, fontSize: 20}}>contact us</a>.
                        </Text.Text>
                        <Text.Text>If you have already contacted our team and have been provided a Client ID and Client Password you can continue with the guide.</Text.Text>
                    </Container>
                </Col>
            </Row>

            {/* Initial Setup */}
            <Row>
                <Col>
                    <Container  className='mt-3' style={{borderWidth:border && 1, borderStyle: border && 'solid' }}>
                        <Text.Heading>2. PRM Connect Documentation</Text.Heading>
                        <Text.Text>In order to gain access to the PRM Connect API, we use JSON Web Tokens to authenticate all requests. These tokens are temporary, and are generated using your client id and client password. The authentication section explains this process. </Text.Text>
                    </Container>
                </Col>
            </Row>

            {/* Additional Resources */}
            <Row>
                <Col>
                    {/*
                    <Container  className='mt-3' style={{borderWidth:border && 1, borderStyle: border && 'solid' }}>
                        <Text.Heading>3. Additional Resources</Text.Heading>
                        <Text.Text>To test your key and to ensure you are receiving some responses from our server. For testing purposes, it is best to use our development server. It can also be helpful to download our Postman API package, which already has all the requests added for testing purposes. Click here to download it.</Text.Text>
                    </Container>*/}

                    <PageNavigator rightText={'Authentication'} rightLink={'/authentication'} leftText={'Introduction'} leftLink={'/introduction'} />

                </Col>
            </Row>
            
            {/* Footer */}
            <Footer small={true} />
        </>
    );
};

export default GettingStarted;